/**
 * Distances maximales (m) de chaque niveau de détail, par catégorie d'asset.
 * Au-delà de la dernière valeur, l'instance n'est pas dessinée. Le réglage
 * de qualité dynamique multiplie toutes ces distances (InstancedLodSet.lodScale).
 */
export const LOD_DISTANCES: Record<string, number[]> = {
  skier: [70, 260, 1100],
  tree: [120, 650, 2600],
  rock: [130, 1000],
  prop: [110, 700],
  carrier: [150, 1100],
  pylon: [220, 2200],
  station: [300, 3200],
  building: [320, 3200],
  house: [260, 2400],
  marker: [90, 450],
};

/**
 * Agrandissement du recul maximal sur les grandes cartes (1 sur Val Cendrée,
 * 1,35 au plus) : la caméra recule davantage et le dernier niveau de détail
 * des sapins et rochers porte d'autant plus loin, pour que la forêt ne
 * disparaisse pas au dézoom.
 */
export function mapViewScale(half: number): number {
  return Math.min(1.35, Math.max(1, Math.sqrt(half / 1024)));
}

/** Distances de LOD dont la dernière (portée d'affichage) est multipliée par k. */
export function farther(distances: number[], k: number): number[] {
  return distances.map((d, i) => (i === distances.length - 1 ? Math.round(d * k) : d));
}
